import React, { useState } from 'react'
import { Box, Tabs, Tab, Container, Paper, Typography, useTheme, useMediaQuery } from '@mui/material'
import { Navbar } from '../features/navigation/components/Navbar'
import { Footer } from '../features/footer/Footer'
import AdminPanelTabs from '../components/AdminPanelTabs'

export const AdminPanelPage = () => {
  const [activeTab, setActiveTab] = useState(0)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  return (
    <>
      <Navbar isProductList={true} />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold', color: 'primary.main' }}>
          🛡️ Admin Control Panel
        </Typography>

        <Paper elevation={3}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange}
            variant={isMobile ? "scrollable" : "standard"}
            scrollButtonsDisplay={isMobile ? "auto" : "off"}
            sx={{ 
              borderBottom: 1, 
              borderColor: 'divider',
              backgroundColor: 'primary.main',
              '& .MuiTab-root': { color: 'white', fontWeight: 600 },
              '& .Mui-selected': { color: 'warning.main' }
            }}
          >
            <Tab label="📦 Products" />
            <Tab label="🏷️ Discounts" />
            <Tab label="🧪 Testers" />
            <Tab label="⭐ Reviews" />
            <Tab label="📋 Orders" />
            <Tab label="⚙️ Settings" />
          </Tabs>

          <Box sx={{ p: 3, minHeight: '60vh' }}>
            <AdminPanelTabs activeTab={activeTab} />
          </Box>
        </Paper>
      </Container>
      <Footer />
    </>
  )
}
